var TilesView = Class({

    initialize: function(containerSel) {
		$.extend(Handlebars.partials,Rayban.templates);
    	this.containerSel = containerSel;
		this.plpTemplate = Rayban.templates["plp-template"];
		this.plpTemplateServer = Rayban.templates["plp-template-server"];
		this.eventType = ((document.ontouchstart!==null) ? "click" : "touchstart");

	},

	render: function(data, toAppend){
		var self = this;
		if(toAppend === true){
			if (undefined !== data && undefined !== data[0] && undefined !== data[0].products && undefined !== data[0].products.pageType && data[0].products.pageType === "ProductListing") {
				$(this.containerSel).append(this.plpTemplateServer(data));
			}else{
				$(this.containerSel).append(this.plpTemplate(data));
			}
		}
		else{
			if(undefined !== data && undefined !== data[0] && undefined !== data[0].products && undefined !== data[0].products.fromPage && data[0].products.fromPage == 'facetedPLP'){
				$(this.containerSel).html(this.plpTemplateServer(data));
			}else{
				$(this.containerSel).html(this.plpTemplate(data));
			}

		}

		self.bindEvent();

	},

	bindEvent: function(){

		var eventType = ((document.ontouchstart!==null) ? "click" : "touchstart");

		$(".quickViewLink").off(eventType).on(eventType, openQuickViewHandler);

		$(".customizeContainer").off(eventType).on(eventType, function(e){
			e.preventDefault();
			var el = e.currentTarget;

			var url = $(el).data('url');
			if((e.ctrlKey === true) || (e.metaKey === true))
				window.open(url, '_newtab');
			else
				window.open(url, '_self');

		});

		$(".colorsCarouselOverlay .tileOverlayContent").off("click").on("click", preventEventPropagation);

		$(".colorsCarouselOverlay .tileOverlayContent ul li").off("click").on("click", colorCarouselClickHandler);

		$(".plp-specific-tile").hover(
		  function () {
		    $(this).children('div.searchPlpTileHeader').find('.promo-cluster-badge').addClass("wcs-hide");
		    $(this).children('div.searchPlpTileHeader').find('.promo-single-badge').removeClass("wcs-hide");

		    $(this).children('div.search-plp-tile-body').find('img.product-image').addClass("wcs-hide");
		    $(this).children('div.search-plp-tile-body').find('img.product-hover-image').removeClass("wcs-hide");

		    $(this).children('div.search-plp-tile-footer-t2t3').find('.desc .plp-clustered').addClass("wcs-hide");
		    $(this).children('div.search-plp-tile-footer-t2t3').find('.desc .plp-non-clustered').removeClass("wcs-hide");
		    $(this).children('div.search-plp-tile-footer-t2t3').find('.desc .styles').addClass("wcs-hide");
		  },
		  function () {
		    $(this).children('div.searchPlpTileHeader').find('.promo-cluster-badge').removeClass("wcs-hide");
		    $(this).children('div.searchPlpTileHeader').find('.promo-single-badge').addClass("wcs-hide");

		    $(this).children('div.search-plp-tile-body').find('img.product-image').removeClass("wcs-hide");
		    $(this).children('div.search-plp-tile-body').find('img.product-hover-image').addClass("wcs-hide");

		    $(this).children('div.search-plp-tile-footer-t2t3').find('.desc .plp-clustered').removeClass("wcs-hide");
		    $(this).children('div.search-plp-tile-footer-t2t3').find('.desc .plp-non-clustered').addClass("wcs-hide");
		    $(this).children('div.search-plp-tile-footer-t2t3').find('.desc .styles').removeClass("wcs-hide");
		  }
		);

		if($('#nextPageSearch') === null || $('#nextPageSearch').length === 0 || $('#nextPageSearch').val() === ""){
			$("#searchResultsLoadMoreContainer").hide();
		}else {
			if($('#clientSide').val() != "true"){
				$("#searchResultsLoadMoreContainer").show();
			}
		}

		$(".colorsCarouselOverlay ul").each(function(){
			var self = $(this);
			if (!$(self).find('li').hasClass('carousel-active')) {
				var plpCarousel = $(this).bxSlider({
					infiniteLoop: false,
					hideControlOnEnd: true,
					slideWidth: 92,
					pager: false,
					minSlides: 1,
					maxSlides: 3,
					moveSlides: 3,
					preloadImages: 'all',
					responsive: false,
					onSliderLoad: function(){
						$(self).find('li').addClass('carousel-active');
						setTimeout(function(){
							if(self.find("li").length == 1){
								$(self.closest(".bx-wrapper").find(".bx-controls .bx-controls-direction a.bx-next")).eq(0).addClass("disabled").removeClass("bx-next");
								$(self.closest(".bx-wrapper").find(".bx-controls .bx-controls-direction a.bx-prev")).eq(0).addClass("disabled").removeClass("bx-prev");
							} else if(self.find("li").length >= 4){
								$(self.closest(".bx-wrapper").find(".bx-controls .bx-controls-direction a.bx-next")).eq(0).removeClass("disabled");
							} else if(self.find("li").length == 2){
								$(self.closest(".bx-wrapper").find(".bx-controls .bx-controls-direction a.bx-next")).eq(0).addClass("disabled").addClass("twotilsvalue");
							} else{
								$(self.closest(".bx-wrapper").find(".bx-controls .bx-controls-direction a.bx-next")).eq(0).addClass("disabled");
							}
						}, 200);
					}
				});
			}
		});

		$(".colorsCarouselOverlay .bx-controls-direction a.bx-prev,.colorsCarouselOverlay .bx-controls-direction a.bx-next").addClass("D_PLP_TilesArrows");

		$.each($(".colorsCarouselOverlay .tileOverlayContent ul"), function(index, value){
			$(this).parents(".carouselBody").siblings(".carouselHeader").find(".selected-class").text($(this).find("li.selected-list-item").index()+1);
    });

    var iniVal = 0;
    var plpTile = 0;

    $(".colorsCarouselOverlay .tileOverlayContent ul li").hover(function () {
      $(this).siblings("li").find(".wcs-carousel-image").removeClass("selected-color");
      $(this).siblings("li").removeClass("selected-color-li");
      $(this).find(".wcs-carousel-image").addClass("selected-color");
      $(this).find(".wcs-carousel-image").parent().addClass("selected-color-li");
      var data = $(this).data();
      plpTile = $(this).parents(".search-plp-tile");
      iniVal = plpTile.find(".search-plp-tile-footer-t2t3 .desc #D_PLP_Installment_Payment").text();
      var prescriptionTile = $(".search-plp-tile-header .rc-label");
      plpTile.find(".colorsCarouselOverlay .carouselHeader .selected-class").text($(this).index() + 1);
      plpTile.find(".colorsCarouselOverlay .carouselHeader .price-range").text(data.pstprice);
      if (!data.pstprice || data.pstprice === "") {
        plpTile.find(".search-plp-tile-footer-t2t3 .desc .actual-price").removeClass('strikeText');
      } else {
        plpTile.find(".search-plp-tile-footer-t2t3 .desc .actual-price").addClass('strikeText');
      }
      plpTile.find(".search-plp-tile-footer-t2t3 .desc .actual-price").text(data.offerprice);
      plpTile.find(".search-plp-tile-footer-t2t3 .desc .sell-price").text(data.pstprice);

      if (data.promobadge) {
        plpTile.find(".searchPlpTileHeader .promo-single-badge").show();
        plpTile.find(".searchPlpTileHeader .promo-single-badge .cluster-badge").text(data.promobadge);
      } else {
        plpTile.find(".searchPlpTileHeader .promo-single-badge").hide();
      }

      if (data.installmentpaymentprice) {
        plpTile.find(".search-plp-tile-footer-t2t3 .desc #D_PLP_Installment_Payment").text(data.installmentpaymentmessage + " " + data.installmentpaymentprice);
      } else {
        plpTile.find(".search-plp-tile-footer-t2t3 .desc #D_PLP_Installment_Payment").hide();
      }

      if (data.imageurl) {
        plpTile.find(".SearchPlpTileBody img.product-image").attr("src", data.imageurl);
        plpTile.find(".SearchPlpTileBody img.product-hover-image").attr("src", data.imageurlhover);
      }
      if (data.remixurl) {
        plpTile.find(".searchPlpTileHeader .customizeContainer").attr("data-url", data.remixurl);
      }
      if (data.pdpurl) {
        plpTile.parent("a").attr("href", data.pdpurl);
      }

      if (!data.prescriptionopticslabel) {
        plpTile.find(prescriptionTile).hide();
      } else {
        plpTile.find(prescriptionTile).show();
      }
    }, function () {
      plpTile.find(".search-plp-tile-footer-t2t3 .desc #D_PLP_Installment_Payment").text(iniVal);
    });

	}


});

var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = unescape(window.location.search.substring(1)),

        sURLVariables = sPageURL.split('&'),

        sParameterName,
        returnStr='',
        i;

    for(var quryParameterIndex=0; quryParameterIndex<sURLVariables.length;quryParameterIndex++){
    	if(sURLVariables[quryParameterIndex].indexOf("=") === -1){
    		sURLVariables[quryParameterIndex-1]=sURLVariables[quryParameterIndex-1]+"&"+sURLVariables[quryParameterIndex];
    		sURLVariables.splice(quryParameterIndex,1);
    	}
    }

    var isAdd= false;
    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {

        	if(sParameterName[1] === undefined){
        		return true;
        	}else {
        		if(isAdd)
        			returnStr +=  "|" + decodeURIComponent(escape(sParameterName[1]));
        		else
        			returnStr =  decodeURIComponent(escape(sParameterName[1]));
        	}
        	isAdd = true;
        }
    }

    if(returnStr.indexOf("|") !=-1){
    	return returnStr.split("|");
    }else {
    	return returnStr;
    }

};

function preventEventPropagation(){
	return false;
}

function colorCarouselHoverHandler(){
  $(this).siblings("li").find(".wcs-carousel-image").removeClass("selected-color");
  $(this).siblings("li").removeClass("selected-color-li");
  $(this).find(".wcs-carousel-image").addClass("selected-color");
  $(this).find(".wcs-carousel-image").parent().addClass("selected-color-li");
	var data = $(this).data();
	var plpTile = $(this).parents(".search-plp-tile");
	var prescriptionTile = $(".search-plp-tile-header .rc-label");
	plpTile.find(".colorsCarouselOverlay .carouselHeader .selected-class").text($(this).index()+1);
	plpTile.find(".colorsCarouselOverlay .carouselHeader .price-range").text(data.pstprice);
	if (!data.pstprice || data.pstprice === "") {
      plpTile.find(".search-plp-tile-footer-t2t3 .desc .actual-price").removeClass('strikeText');
    } else {
      plpTile.find(".search-plp-tile-footer-t2t3 .desc .actual-price").addClass('strikeText');
    }
	plpTile.find(".search-plp-tile-footer-t2t3 .desc .actual-price").text(data.offerprice);
	plpTile.find(".search-plp-tile-footer-t2t3 .desc .sell-price").text(data.pstprice);

	if(data.promobadge){
		plpTile.find(".searchPlpTileHeader .promo-single-badge").show();
		plpTile.find(".searchPlpTileHeader .promo-single-badge .cluster-badge").text(data.promobadge);
	} else {
		plpTile.find(".searchPlpTileHeader .promo-single-badge").hide();
	}
	if(data.imageurl){
		plpTile.find(".SearchPlpTileBody img.product-image").attr("src",data.imageurl);
		plpTile.find(".SearchPlpTileBody img.product-hover-image").attr("src",data.imageurlhover);
	}
	if(data.remixurl){
		plpTile.find(".searchPlpTileHeader .customizeContainer").attr("data-url",data.remixurl);
	}
	if(data.pdpurl){
		plpTile.parent("a").attr("href",data.pdpurl);
	}

	if(!data.prescriptionopticslabel){
		plpTile.find(prescriptionTile).hide();
	} else {
		plpTile.find(prescriptionTile).show();
	}
}

function colorCarouselClickHandler(){
	var data = $(this).data();
	window.location.href = data.pdpurl;

}

function searchResultsLoadMoreContainer(){
	$("#searchResultsLoadMoreContainer .paging_controls").off("click").on("click", function(e){
		e.preventDefault();
		var url=location.href;

		$(".wcs-loading-icon-wrapper").show();
		$(".wcs-loading-icon-wrapper").css("padding-bottom", "115px");
		$("#searchResultsLoadMoreContainer").hide();
		var prams = {};
		var newPageNumber=parseInt($('#pageNumber').val())+1;
		if($("#pageType").val() =='SearchResults' && !isNaN(parseInt(getUrlParameter('pageSize'))) &&
				!isNaN(parseInt($('#defaultPageSize').val())) && parseInt($('#defaultPageSize').val())!==0){
			newPageNumber = (parseInt(getUrlParameter('pageSize'))/parseInt($('#defaultPageSize').val()))+1;
			newPageNumber = Math.round(newPageNumber);
		}
		$('#pageNumber').val(newPageNumber);
		var pageSize=parseInt($('#pageSize').val())+parseInt($('#facetPageSize').val());
		if($("#pageType").val() =='SearchResults'){
			pageSize=parseInt($('#defaultPageSize').val())+parseInt($('#pageSize').val());
		}
		if($("#pageType").val()=== undefined && url.indexOf('facet=') != -1){
			if(!isNaN(parseInt(getUrlParameter('pageSize')))){
				pageSize=parseInt($('#facetPageSize').val())+parseInt(getUrlParameter('pageSize'));
			}else{
				pageSize=parseInt($('#pageSize').val())+parseInt($('#facetPageSize').val());
			}

		}
		$("#shownProductCount span:first-child").text(" "+pageSize);
		$('#pageSize').val(pageSize);

		if($("#pageType").val() =='SearchResults'){
			//caluation and set as true
			var customPagination = false;
			var divideValue = parseInt(pageSize/parseInt($('#newPageSize').val()));
			if(!isNaN(divideValue) && divideValue % 2 !== 0){
				customPagination = true;
			}
			prams = {
					"viewMode" : $("#viewMode").val(),
					"searchType": $("#searchType").val(),
					"searchTermScope": $("#searchTermScope").val(),
					"sType": $("#sType").val(),
					"newpage": $("#newpage").val(),
					"facet": getUrlParameter('facet'),
					"clientSide": $("#clientSide").val(),
					"pageNumber":newPageNumber,
					"pageSize": $("#defaultPageSize").val(),
					"searchTerm" : getUrlParameter('searchTerm').split("+").join(" "),
					"enableCustomPagination" : customPagination
			};

			// incresing size after click load more
			var doublePageSize = parseInt($('#newPageSize').val()) * 4;
			$('#defaultPageSize').val(doublePageSize);
		}


		url = (url.indexOf("?")!=-1) ?
				(url.indexOf("pageSize")!=-1) ?
						url.replace(/pageSize=[^&]+/,'pageSize='+pageSize) : url+'&pageSize='+pageSize :
			   url+'?pageSize='+pageSize;


		history.replaceState(null, null, url);
		$.ajax({
			url: $('#nextPageSearch').val(),
			data: prams,
			traditional : true,
			success: function(resp){

				$(".wcs-loading-icon-wrapper").hide();
				$(".wcs-loading-icon-wrapper").css("padding-bottom", "0");
				$("#searchResultsLoadMoreContainer").show();
				loadMoreProducts(resp);
			}
		});
	});
}

function loadMoreProducts(resp){

	if(typeof resp != "object")
		resp = $.parseJSON(resp);

	var totalCount = Number(resp.totalCount);
	var productData ;
	var products = $.parseJSON(resp.products);


	if(products.result)
		productData = products.result.Category;
	else
		productData = new Array(products);

	var scrollToEl = $(".plp-tile").last();

	window.plpView.render(productData, true);

	if(resp.nextPageURL){
		$("#searchResultsLoadMoreContainer").show();
		var loadMoreURL = resp.nextPageURL.split("amp;").join("");
		$("#nextPageSearch").val(loadMoreURL);

	}else {
		$("#searchResultsLoadMoreContainer").hide();

	}


	if($("#pageType").val()== "SearchResults"){
		var searchTiles = $(".categories").last().children();
		$(".categories").last().remove();
		$(".categories").first().append(searchTiles);
	}

	$('html, body').animate({
        scrollTop: scrollToEl.offset().top
    }, 300);

}

function openQuickViewHandler(e){
	e.preventDefault();
	e.stopPropagation();
	var	el = e.currentTarget;


	var params = {
		"category_Id"     : $(el).data("catgroupid"),
		"catentryId"     : $(el).data("catentryid"),
		"catalogId"      : $("#catalogId").val(),
		"storeId"        : $("#storeId").val(),
		"langId"         : $("#langId").val(),
		"responseFormat" : "json"
	};

	if($('#pdp_page').length > 0){
        $(el).closest(".wcs-quick-buy").prev(".qv-overlay").show();
    }
	else if($(".clearance-quick-view") && ($(".clearance-quick-view").length >0)){
		$(el).closest(".clearance-quick-view").find(".qv-overlay").show();
	}
	else{
        $(el).closest(".plp-tile").find(".qv-overlay").show();
    }

	var quickViewAjax = $.getJSON($(".quickViewAjax").text(), params, function(data) {

   //      if($(el).data("isrox") == "Prescription"){
   //      	$(".quickview-popup").attr("id","D_QuickView_Prod");
			// $(".quickview-popup").addClass("quickView-rox");
   //      }
   //      else{
   //          $(".quickview-popup").attr("id","D_QuickView");
			// $(".quickview-popup").removeClass("quickView-rox");
   //      }
		var quickviewData = [];
		quickviewData[0]=data.colors;
		quickviewData[1]=data.products;
		window.isROX = "";
		if($.trim($(el).data("isrox").toLowerCase()) == "prescription" || ($("#isRoxEnabled").length>0 && $("#isRoxEnabled").val() === "true")) window.isROX = "true";
		var pObj = getQuickViewValue(quickviewData, $(el).attr('id'));
		window.quickviewpopup = new QuickViewSummary(quickviewData);
		$(".qv-overlay").hide();

		if($.trim($(el).data("isrox").toLowerCase()) == "prescription" || ($("#isRoxEnabled").length>0 && $("#isRoxEnabled").val() === "true")){
			QuickviewRox.prototype = window.quickviewpopup;
			QuickviewRox.prototype.constructor = QuickviewRox;
			window.quickviewRox = new QuickviewRox();
			quickviewRox.render();
		}
		else{
		    quickviewpopup.render();
		}


	}).error(function(request){
		tealium_data2track = tealium_data2track || [];
    	tealium_data2track.push({
    		id: 'WCS-D-QuickViewOverlay-Loading-Error',
    		Error_Source: 'Server',
    		Error_Code: request.responseText
    	});
	});

	/*quickViewAjax.complete(function(){
		//Script provided by Jarno, Ticket no RB-5326
		tealium_data2track = tealium_data2track || [];
	    tealium_data2track.push({id:'WCS-D-ListingPage-QuickViewOverlay'});

	});*/
}

function getQuickViewValue(arr, value){
   var o;
  for (var i=0, iLen=arr.length; i<iLen; i++) {
    o = arr[i];
	return o;
  }
}

var readCookie = function (name) {
	var nameEQ = name + "=";
	var cookieArray = document.cookie.split(';');
	for (var i = 0; i < cookieArray.length; i++) {
		var cookieItem = cookieArray[i];
		while (cookieItem.charAt(0) == ' ') cookieItem = cookieItem.substring(1, cookieItem.length);
		if (cookieItem.indexOf(nameEQ) == 0) return cookieItem.substring(nameEQ.length, cookieItem.length);
	}
	return null;
};
